const pixelsCategories = ["PERFORMANCE","TARGETING","SOCIAL","STRICTLY_NECESSARY"];

export { pixelsCategories };